import { ICDSOptions } from '../interfaces/icdsoptions';
import { ICDSConfig } from '../interfaces/icdsconfig';
import { ICDSDependencies } from '../interfaces/icdsdependencies';
import { BehaviorSubject } from 'rxjs';
import { Status } from '../enums/status';
import { ParamsType } from '../interfaces/icds';
import { coreVendors } from '@nexxe/core-vendors';
import { IContext } from '../interfaces/irequestmetadata';

export const cache_control = { 'Cache-Control': 'max-age=3600' };

// @dynamic
export class CDSMetadata {

	private static _cdsDataComposer: any;
	public static get cdsDataComposer(): any {
		return CDSMetadata._cdsDataComposer;
	}
	public static set cdsDataComposer(value: any) {
		CDSMetadata._cdsDataComposer = value;
	}

	private _endpoint: string;
	private _method: string;
	private _dependencies?: ICDSDependencies[];
	private _cache?: boolean;
	private _expireAge?: number;
	private _retry?: number;
	private _externalUrl: string;
	private _overridedInterceptor?: Object;
	private _extraHeaders?: Object;
	private _autoInvoke?: number;
	private _baseUrl: string;
	private _header: Object;
	private _baseInterceptor: Object;
	private _queryParams: Object;
	private _outputPath: string;
	lastSuccess: number;
	status: Status;
	expireAge: number;
	observable: BehaviorSubject<any>;
	private _payload: Object;
	key: string;
	withCredentials: boolean;
	id: string;
	private _responseType: string
	constructor(key, options: ICDSOptions, config: ICDSConfig, id: string, context?: IContext) {
		this.id = id;
		this.key = key
		this._autoInvoke = options.autoInvoke;
		this._cache = options.cache;
		this._endpoint = this.resolveParamsInString(options.endpoint, context);
		this._dependencies = options.dependencies;
		this._expireAge = options.expireAge ? options.expireAge : 0;
		this._externalUrl = this.resolveParamsInString(options.externalUrl, context);
		this._overridedInterceptor = options.overridedInterceptor;
		this._extraHeaders = this.resolveParamsOrPayload(coreVendors.lodash.cloneDeep(options.extraHeaders), context);
		this._method = options.method;
		this.status = options.status ? options.status : Status.notUsed;
		this._retry = options.retry;
		this.lastSuccess = options.lastSuccess ? options.lastSuccess : 0;
		this.expireAge = options.expireAge ? options.expireAge : 1;
		this._baseUrl = this.resolveParamsInString(config.baseUrl, context);
		this._header = { ... this.resolveParamsOrPayload(coreVendors.lodash.cloneDeep(config.header), context) };
		this._baseInterceptor = config.baseInterceptor;
		this._queryParams = this.resolveParamsOrPayload(coreVendors.lodash.cloneDeep(options.queryParams), context);
		this._payload = this.resolveParamsOrPayload(coreVendors.lodash.cloneDeep(options.payload), context);
		this.withCredentials = options.withCredentials ? options.withCredentials : false;
		this._outputPath = options.outputPath
		this._responseType = options.responseType
	}

	private resolveParamsOrPayload(paramsOrPayload: Object, context?: IContext): Object {
		return CDSMetadata.cdsDataComposer.resolveParams(paramsOrPayload, context);
	}

	private resolveParamsInString(url: string, context?: IContext): string {
		return CDSMetadata.cdsDataComposer.resolveParamsInString(url, context);
	}


	get responseType() {
		return this._responseType;
	}

	get outputPath() {
		return this._outputPath;
	}


	get method() {
		return this._method;
	}

	get options() {
		return {
			retry: this._retry,
			expireAge: this._expireAge,
			autoInvoke: this._autoInvoke
		};
	}

	get endpoint() {
		return (!this._externalUrl) ? this._baseUrl + this._endpoint : this._externalUrl;
	}

	get headers() {
		var header;
		if (this._extraHeaders) header = Object.assign(this._header, this._extraHeaders)
		if (this._cache) header = Object.assign(this._header, cache_control);
		if (this._overridedInterceptor) header = Object.assign(this._header, this._overridedInterceptor);
		else header = Object.assign(this._header, this._baseInterceptor);
		//Header values can only be string type and any boolean/numeric values will be removed from the headers.
		//converting the numeric or boolean values to string will help retain the values in the headers. 
		for (let prop in header) {
			if ((header[prop] !== undefined || header[prop] !== null) && typeof header[prop] !== 'string') {
				header[prop] = header[prop].toString();
			}
		}
		return header;
	}

	get dependencies() {
		return this._dependencies
	}

	get queryParams() {
		return this._queryParams;
	}

	get payload() {
		return this._payload;
	}



	get isExpired(): boolean {
		const expireTime = this.lastSuccess + (this.expireAge * 60000);
		const currentTime: Number = (new Date()).getTime() / 60000;
		return (this.lastSuccess == 0 || (this.expireAge > 0 && currentTime > expireTime)) ? true : false;
	}


}